import src from '/Users/huynhducduy/workspace/innosearch/innosearch-fe/interface/src/assets/homepage/hero-background-mobile.jpg?url';

export default {
  lqip: `data:image/jpeg;base64,UklGRqgAAABXRUJQVlA4IJwAAAAwBQCdASoSACAAPm0ylEekIqIhKAgAgA2JZgCdMoR/doABxFw0dMaKC13Rc6IN6SfGAAD+9dWRBoVhGhRtq1qE77mlal6/mH9jXd/65rAcdv+cjRP/yK+/OVQgONibAitf/+KDT/8X/ipbNfniy/vfwwedZsgTOpXQ+jJPHW8fuddPcucmNfLewLhEdpPHCF42zNh8n63OsOSfygA=`,
  src,
  width: 1216,
  height: 2160,
};
			